<template>
    <div>
        <div class="aFlex fchart-box-top">
            <div class="main-credit-item" :class="{active:isPayroll===1}"
                 @click="handlePay(1)">已发项目</div>
            <div class="main-credit-item" :class="{active:isPayroll===0}"
                 @click="handlePay(0)">未发项目</div>
        </div>
        <div class="fchart-bi" style="padding: 12px">
            <Table :loading="loading_t" :columns="tColumns" :data="payData"
                   size="small"  border :show-header="false" highlight-row>
                <template slot-scope="{ row, index }" slot="projectName">
                    <span class="ft-bold-blue">{{row.projectName}}</span>
                </template>
            </Table>
            <div class="aFlex" style="margin-top: 10px">
                <Page style="margin-left: auto" size="small"
                      :current="page_t" :total="total_t"
                      @on-change="changePage_t"
                      prev-text="上一页" next-text="下一页" />
                <!--<Button style="margin-left: 15px" type="primary" size="small">查看全部</Button>-->
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        data(){
            return {
                isPayroll:1,
                loading_t:false,
                page_t:1,
                total_t:0,
                tColumns:[
                    {
                        title: '项目名称',
                        slot: 'projectName',
                        minWidth:100
                    },
                    {
                        title: '地区',
                        key: 'areaName'
                    },
                    {
                        title: '单位名称',
                        key: 'companyName'
                    }
                ],
                payData:[],
            };
        },
        props: {
            areaCode:{
                type: [String,Number]
            },
            dateMonth:{
                type: [String,Number]
            },
        },
        computed: {

        },
        mounted(){
            this.getData()
        },
        watch: {

        },
        methods: {
            getData() {
                this.page_t=1;
                this.querySummaryPayOffList();
            },
            // 切换已发 未发
            handlePay(name){
                this.isPayroll=name;
                this.page_t=1;
                this.querySummaryPayOffList();
            },
            // 页码数改变
            changePage_t(value){
                this.page_t=value;
                this.querySummaryPayOffList();
            },
            // 工资发放 已发/未发列表
            querySummaryPayOffList(){
                this.loading_t=true;
                this.axios({
                    method: 'post',
                    url: '/summary/querySummaryPayOffList',
                    data:{
                        areaCode:this.areaCode,
                        date:this.dateMonth,
                        isPayroll:this.isPayroll,
                        size:10,
                        current:this.page_t,
                    }
                }).then( (response)=> {
                    this.loading_t=false;
                    // console.log(response)
                    if (response.data.success){
                        this.total_t = response.data.data.total;
                        this.payData=response.data.data.records;
                    }
                }).catch(()=>{
                    this.loading_t=false;
                });
            },

        }
    };
</script>
<style scoped>
    .main-credit-item{
        padding: 0 10px;
        /* padding-top: 5px; */
        line-height: 50px;
        border-bottom: 2px solid transparent;
        cursor: pointer;
        transition: color .3s ease-in-out;
    }
    .main-credit-item.active{
        color: #0099FF;
        border-bottom-color: #0099FF;
    }
</style>
